// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading-module_spinner__tnkS2{display:flex;justify-content:center;align-items:center;gap:var(--spacing-xxxSmall);margin-top:var(--spacing-large)}`, "",{"version":3,"sources":["webpack://./src/App/components/Loading.module.css"],"names":[],"mappings":"AAAA,+BAAS,YAAY,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,2BAA2B,CAAC,+BAA+B","sourcesContent":[".spinner{display:flex;justify-content:center;align-items:center;gap:var(--spacing-xxxSmall);margin-top:var(--spacing-large)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `Loading-module_spinner__tnkS2`
};
export default ___CSS_LOADER_EXPORT___;
